<template>
  <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="title">
    <div>
      <b-row>
        <b-col>
          <b-form @submit.prevent="save">
            <b-card>
              <b-row>
                <b-col cols="6">
                  <b-form-group class="mb-1">
                    <lg-form-select v-model="form.tipoEmpresa" :loadFunction="tipoEmpresaList"
                      labelFormGroupBind="Tipo de Empresa:*" label="descricao"
                      invalidFeedback="O tipo deve ser informado!" description="" :error="$v.form.tipoEmpresa" />
                  </b-form-group>

                  <b-form-group class="mb-1">
                    <lg-form-input invalidFeedback="Informe uma razão social válida!" description=""
                      :error="$v.form.dadosEmpresa.razaoSocial" v-model="form.dadosEmpresa.razaoSocial"
                      label="Razão Social:*" />
                  </b-form-group>
                  <b-form-group class="mb-1">
                    <lg-form-input invalidFeedback="Informe nome fantasia válido!" description=""
                      :error="$v.form.dadosEmpresa.nomeFantasia" v-model="form.dadosEmpresa.nomeFantasia"
                      label="Nome fantasia:*" />
                  </b-form-group>
                  <b-form-group class="mb-1">
                    <lg-form-input-mask :invalidFeedback="`Informe um ${form.tipoEmpresa.descricao == 'Física'
                      ? 'CPF'
                      : form.tipoEmpresa.descricao == 'Jurídica'
                        ? 'CNPJ'
                        : 'Registro'
                      } válido!`" :mask="form.tipoEmpresa.descricao == 'Física'
                        ? '###.###.###-##'
                        : form.tipoEmpresa.descricao == 'Jurídica'
                          ? '##.###.###/####-##'
                          : ''
                        " description="" :error="$v.form.registro" v-model="form.registro" :label="form.tipoEmpresa.descricao == 'Física'
                          ? 'CPF:*'
                          : form.tipoEmpresa.descricao == 'Jurídica'
                            ? 'CNPJ:*'
                            : 'Registro'
                          " />
                  </b-form-group>
                  <b-form-group class="mb-1">
                    <lg-form-input invalidFeedback="Informe uma observação válida!" description=" "
                      :error="$v.form.observacao" v-model="form.observacao" label="Observação:" />
                  </b-form-group>
                  <b-form-group class="mb-1">
                    <lg-form-const-select v-model="form.porteEmpresa" :options="porteEmpresaOptions"
                      label="Porte da Empresa:" description=" " />
                  </b-form-group>
                  <b-form-group class="mb-1">
                    <lg-form-input-mask mask="R$ ###.###.###,00" invalidFeedback="Informe um valor válido!" description=" "
                      v-model="form.capitalSocial" label="Capital Social:" />
                  </b-form-group>
                  <b-form-group class="mb-1">
                    <lg-form-input-mask mask="R$ ###.###.###,00" invalidFeedback="Informe um valor válido!" description=" "
                      v-model="form.patrimonio" label="Patrimônio:" />
                  </b-form-group>
                  <b-form-group class="mb-1">
                    <lg-form-input invalidFeedback="Informe uma linha de fornecimento válida!" description=" "
                      v-model="form.linhaFornecimento" label="Linha de Fornecimento:" />
                  </b-form-group>
                  <b-form-group class="mb-1">
                    <div class="d-flex align-items-center">
                      <label class="mr-3 mb-1 pl-3" style="color: inherit; font-size: 12px">Status: *</label>
                      <b-form-radio-group size="sm" v-model="form.situacao" :options="options" name="situacao-options"
                        class="d-flex">
                      </b-form-radio-group>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="1">
                  <div class="vertical-line"></div>
                </b-col>
                <b-col cols="5">
                  <b-card>
                    <b-list-group>
                      <b-list-group-item>
                        <b-button id="enderecos" class="my-2" size="sm" pill variant="primary"
                          @click="abrirModalEndereco">
                          <b-icon icon="geo-alt" />
                          <b-tooltip target="enderecos" title="Endereços..." triggers="hover"></b-tooltip>
                        </b-button>
                        &nbsp;Endereço
                      </b-list-group-item>
                      <b-list-group-item>
                        <b-button id="enderecosEletronicos" class="my-2" size="sm" pill variant="primary"
                          @click="abrirModalEnderecoEletronico">
                          <b-icon icon="envelope" />
                          <b-tooltip target="enderecosEletronicos" title="Endereços Eletrônicos..."
                            triggers="hover"></b-tooltip>
                        </b-button>
                        &nbsp;Endereço Eletrônico
                      </b-list-group-item>
                      <b-list-group-item>
                        <b-button id="telefones" class="my-2" size="sm" pill variant="primary"
                          @click="abrirModalTelefone">
                          <b-icon icon="telephone" />
                          <b-tooltip target="telefones" title="Telefones..." triggers="hover"></b-tooltip>
                        </b-button>
                        &nbsp;Telefone
                      </b-list-group-item>
                      <b-list-group-item>
                        <b-button id="contasBancarias" class="my-2" size="sm" pill variant="primary"
                          @click="abrirModalContaBancaria">
                          <b-icon icon="credit-card" />
                          <b-tooltip target="contasBancarias" title="Contas Bancárias..." triggers="hover"></b-tooltip>
                        </b-button>
                        &nbsp;Conta Bancária
                      </b-list-group-item>
                      <b-list-group-item>
                        <b-button id="cnaes" class="my-2" size="sm" pill variant="primary"
                          @click="abrirModalCnae">
                          <b-icon icon="diagram-3" />
                          <b-tooltip target="cnaes" title="CNAEs..." triggers="hover"></b-tooltip>
                        </b-button>
                        &nbsp;CNAE
                      </b-list-group-item>
                    </b-list-group>
                  </b-card>
                </b-col>
              </b-row>
              <div class="d-flex justify-content-center mt-3">
                <b-button type="submit" variant="success" style="height: 30px" pill size="sm">
                  <div>
                    <b-icon icon="check-circle" />
                  </div>
                </b-button>
                <b-button class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
                  <div>
                    <b-icon icon="x-circle" />
                  </div>
                </b-button>
              </div>
            </b-card>
          </b-form>
        </b-col>
      </b-row>
      <b-row v-if="loading">
        <b-col class="text-center">
          <b-spinner class="align-middle"></b-spinner>
        </b-col>
      </b-row>
      <ModalEnderecos v-if="showModalEnderecos" @close="closemodal" :isModal="true" :id="savedId"
        :empresaNome="empresaNome" :codEmpresa="savedId" :prefix="prefix"></ModalEnderecos>
      <ModalEnderecoEletronico v-if="showModalEnderecoEletronico" @close="closemodal" :isModal="true" :id="savedId"
        :empresaNome="empresaNome" :codEmpresa="savedId" :prefix="prefix"></ModalEnderecoEletronico>
      <ModalTelefone v-if="showModalTelefone" @close="closemodal" :isModal="true" :id="savedId"
        :empresaNome="empresaNome" :codEmpresa="savedId" :prefix="prefix"></ModalTelefone>
      <ModalContaBancaria v-if="showModalContaBancaria" @close="closemodal" :isModal="true" :id="savedId"
        :empresaNome="empresaNome" :codEmpresa="savedId" :prefix="prefix"></ModalContaBancaria>
      <ModalCnae v-if="showModalCnae" @close="closemodal" :isModal="true" :id="savedId"
        :empresaNome="empresaNome" :codEmpresa="savedId" :prefix="prefix"></ModalCnae>
    </div>
  </b-modal>
</template>

<style scoped>
.vertical-line {
  border-left: 1px solid #dee2e6;
  height: 100%;
}
</style>

<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormInputMask from "@/core/components/Form/LgFormInputMask.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import ModalEnderecos from "../../../core/components/Modals/ModalEndereco.vue";
import ModalEnderecoEletronico from "../../../core/components/Modals/ModalEnderecoEletronico.vue";
import ModalTelefone from "../../../core/components/Modals/ModalTelefone.vue";
import ModalContaBancaria from "../../../core/components/Modals/ModalContaBancaria.vue";
import ModalCnae from "../../../core/components/Modals/ModalCnae.vue";

export default {
  components: {
    LgFormSelect,
    LgFormInput,
    LgFormInputMask,
    LgFormConstSelect,
    ModalEnderecos,
    ModalEnderecoEletronico,
    ModalTelefone,
    ModalContaBancaria,
    ModalCnae,
  },
  props: {
    isModal: Boolean,
    id: Number,
    prefix: Array,
    empresaNome: String,
  },
  mixins: [FormResourceMixin],
  validations: {
    form: {
      dadosEmpresa: { razaoSocial: { required } },
      registro: { required },
      situacao: {},
    },
  },
  data() {
    return {
      showModalEnderecos: false,
      showModalEnderecoEletronico: false,
      showModalTelefone: false,
      showModalContaBancaria: false,
      showModalCnae: false,
      form: {
        registro: "",
        tipoEmpresa: { id: 2, descricao: "Jurídica" },
        dadosEmpresa: { razaoSocial: "" },
        situacao: null,
        porteEmpresa: null,
        capitalSocial: null,
        patrimonio: null,
        linhaFornecimento: "",
      },
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      porteEmpresaOptions: [
        { value: "MEI", text: "MEI – Microempreendedor Individual" },
        { value: "ME", text: "ME – Microempresa" },
        { value: "EPP", text: "EPP – Empresa de Pequeno Porte" },
        { value: "MEDIO", text: "Médio Porte" },
        { value: "GRANDE", text: "Grande Porte" },
        { value: "PESSOA_FISICA", text: "Pessoa Física" },
        { value: "ESTRANGEIRA", text: "Estrangeira" },
      ],
      showModal: true,
      savedId: this.id || null,
      loading: false,
    };
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, this.id == null ? "Cadastro" : "Alteração"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/empresa`);
    this.$tiposEmpresaService = new ResourceService(`/api/tiposempresa`);
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id);

      // Format monetary values before assigning to form
      if (data.capitalSocial !== null && data.capitalSocial !== undefined) {
        // Format as Brazilian currency (R$)
        data.capitalSocial = this.formatCurrency(data.capitalSocial);
      }

      if (data.patrimonio !== null && data.patrimonio !== undefined) {
        // Format as Brazilian currency (R$)
        data.patrimonio = this.formatCurrency(data.patrimonio);
      }

      this.form = data;
    } else {
      this.form.situacao = 1;
    }
  },
  methods: {
    cancelar() {
      this.$emit("close");
    },
    closemodal() {
      this.showModalEnderecos = false;
      this.showModalEnderecoEletronico = false;
      this.showModalTelefone = false;
      this.showModalContaBancaria = false;
      this.showModalCnae = false;
    },
    formatCurrency(value) {
      // Format number as Brazilian currency (R$)
      if (value === null || value === undefined) return null;

      // Convert to number if it's a string
      const numValue = typeof value === 'string' ? parseFloat(value) : value;

      // Format with Brazilian locale
      return `R$ ${numValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    },
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch();
        this.$notify({
          type: "danger",
          message: "OPS! Verifique os campos do cadastro.",
        });
        return;
      }

      // Convert monetary values from masked format to numeric values
      const formData = { ...this.form };

      // Process Capital Social
      if (formData.capitalSocial && typeof formData.capitalSocial === 'string') {
        // Remove 'R$ ' prefix and replace dots and commas
        formData.capitalSocial = formData.capitalSocial
          .replace('R$ ', '')
          .replace(/\./g, '')
          .replace(',', '.');

        // Convert to number
        formData.capitalSocial = parseFloat(formData.capitalSocial) || null;
      }

      // Process Patrimônio
      if (formData.patrimonio && typeof formData.patrimonio === 'string') {
        // Remove 'R$ ' prefix and replace dots and commas
        formData.patrimonio = formData.patrimonio
          .replace('R$ ', '')
          .replace(/\./g, '')
          .replace(',', '.');

        // Convert to number
        formData.patrimonio = parseFloat(formData.patrimonio) || null;
      }

      this.loading = true;
      const response = await this.$saveResource(
        formData,
        "listarEmpresa",
        true,
        {},
        this.isModal
      );
      if (response && response.data && response.data.id) {
        this.savedId = response.data.id;
      }
      this.loading = false;
    },
    async tipoEmpresaList({ filter, page = 1 }) {
      return this.$tiposEmpresaService.findAll({ filter, page, limit: 5 });
    },
    abrirModalEndereco() {
      if (this.savedId == null) {
        this.$notify({
          type: "danger",
          message: "É necessário salvar antes de prosseguir",
        });
      } else {
        this.codEmpresa = this.form.id;
        this.nomeEmpresa = this.form.razaoSocial;
        this.showModalEnderecos = true;
      }
    },
    abrirModalEnderecoEletronico() {
      if (this.savedId == null) {
        this.$notify({
          type: "danger",
          message: "É necessário salvar antes de prosseguir",
        });
      } else {
        this.codEmpresa = this.form.id;
        this.nomeEmpresa = this.form.razaoSocial;
        this.showModalEnderecoEletronico = true;
      }
    },
    abrirModalTelefone() {
      if (this.savedId == null) {
        this.$notify({
          type: "danger",
          message: "É necessário salvar antes de prosseguir",
        });
      } else {
        this.codEmpresa = this.form.id;
        this.nomeEmpresa = this.form.razaoSocial;
        this.showModalTelefone = true;
      }
    },
    abrirModalContaBancaria() {
      if (this.savedId == null) {
        this.$notify({
          type: "danger",
          message: "É necessário salvar antes de prosseguir",
        });
      } else {
        this.codEmpresa = this.form.id;
        this.nomeEmpresa = this.form.razaoSocial;
        this.showModalContaBancaria = true;
      }
    },
    abrirModalCnae() {
      if (this.savedId == null) {
        this.$notify({
          type: "danger",
          message: "É necessário salvar antes de prosseguir",
        });
      } else {
        this.codEmpresa = this.form.id;
        this.nomeEmpresa = this.form.razaoSocial;
        this.showModalCnae = true;
      }
    },
  },
};
</script>
